import { ThunkType } from "../../../../core/store/reducers";
import deleteTransportFeeApi from "../api/deleteTransportFee";
import { setFetchState } from "../transportFeesDataReducer";

export const deleteTransportFee = (id: number): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return;
  }

  dispatch(setFetchState({ type: "started" }));

  const { userId } = store.data.auth.current.user;
  const result = await dispatch(deleteTransportFeeApi(userId, id));

  dispatch(
    setFetchState(
      result !== undefined ? { type: "successful" } : { type: "error" }
    )
  );
};
